import { createAsyncThunk } from "@reduxjs/toolkit";
import { subscribeNewsletter } from "./newsletter.service";
import { NewsletterPayload, NewsletterResponse } from "./newsletter.types";
import { RejectValueType } from "../redux/redux.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const postNewsletter = createAsyncThunk<
  NewsletterResponse,
  NewsletterPayload,
  RejectValueType
>("newsletter/postNewsletter", async (data, { rejectWithValue }) => {
  try {
    const response = await subscribeNewsletter(data);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
